import styled from 'styled-components';

export const BreadContainer = styled.div`
    display: flex;
    margin-bottom: 20px;
    font-size: 14px;
`;
